import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import * as Dropdown from 'components/Dropdown';

class DistributionTypeDropdownComponent extends React.PureComponent {
  static propTypes = {
    options: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
      }).isRequired
    ).isRequired,

    onChange: PropTypes.func.isRequired
  }

  render () {
    return (
      <div className="main-dropdown mb-20">
        <p className="main-dropdown__label">
          Distribution Selection
        </p>

        <Field
          name="type"
          options={this.props.options}
          onChange={this.props.onChange}
          id="distribution-type-dropdown"
          component={Dropdown.ReduxFormWrapper}
        />
      </div>
    );
  }
}

export default DistributionTypeDropdownComponent;
